import { UnidadePaginateResponse } from "core/features/unidades/typings/unidade";
import { PaginateResult } from "core/resources/types/shared";
import useListagemUnidadeColumns from "./components/useListagemUnidadeColumns";
import HeaderTable from "./components/HeaderTable";
import { useLoading } from "components/GlobalLoading";
import { showConfirm2 } from "infra/helpers/alerta";
import useDeleteUnidade from "core/features/unidades/useDeleteUnidade";
import NewTable from "../../../../NewTable";
import { RiFileEditFill, RiHistoryFill } from "react-icons/ri";
import { MdOutlineCheck } from "react-icons/md";
import { IoMdTrash } from "react-icons/io";
import ModalHistorico from "./components/ModalHistorico/index";
import { useState } from "react";
import ModalExportCertidaoNegativaDebitos from "components/CertidaoNegativaDebitos/ModalExportCertidaoNegativaDebitos";
import { Flex } from "@chakra-ui/react";
import OutlineButton from "ui/components/Button/OutlineButton";
import history from "infra/helpers/history";

interface UnidadesTableProps {
  data: PaginateResult<UnidadePaginateResponse> | undefined;
  onPaginate: (page: number, pageSize: number) => any;
  searchValue: string;
  onSearch: (q?: string) => any;
  isLoading?: boolean;
  onClickRow: (data: UnidadePaginateResponse) => any;
  onDeleted?: any;
}

function UnidadesTable({
  data,
  searchValue,
  onPaginate,
  onSearch,
  isLoading,
  onClickRow,
  onDeleted,
}: UnidadesTableProps) {
  const [idUnidadeHistorico, setIdUnidadeHistorico] = useState<
    string | undefined
  >();
  const [idCertidaoNegativa, setIdCertidaoNegativa] = useState<
    string | undefined
  >();
  const columns = useListagemUnidadeColumns();

  const { mutate: deleteUnidade, isLoading: isLoadingDelete } =
    useDeleteUnidade();

  const onDelete = (unidade: UnidadePaginateResponse) => {
    showConfirm2({
      onOk: () => {
        deleteUnidade(unidade.id, { onSuccess: () => onDeleted() });
      },
    });
  };

  useLoading(isLoadingDelete);
  return (
    <>
      <NewTable
        title={() => (
          <Flex alignItems="center">
            <HeaderTable value={searchValue} onSearch={onSearch} />
            <OutlineButton
              ml="auto"
              fontSize={14}
              h="30px"
              onClick={() => history.push("/cadastros/unidades-unificadas")}
            >
              Unificação de cobranças
            </OutlineButton>
          </Flex>
        )}
        loading={isLoading}
        columns={columns}
        dataSource={data?.items ?? []}
        customPagination={{
          onChangePage: onPaginate,
          currentPage: data?.meta.currentPage ?? 0,
          itemsPerPage: data?.meta.itemsPerPage ?? 0,
          totalItems: data?.meta.totalItems ?? 0,
        }}
        actions={[
          {
            title: "Editar",
            icon: () => <RiFileEditFill size={22} />,
            onClick: (record) => {
              onClickRow(record);
            },
          },
          {
            title: "Histórico",
            icon: () => <RiHistoryFill size={22} />,
            onClick: (v: UnidadePaginateResponse) => {
              setIdUnidadeHistorico(v.id);
            },
          },
          {
            title: "Certidão negativa de débitos",
            icon: () => <MdOutlineCheck size={22} />,
            onClick: (v: UnidadePaginateResponse) => {
              setIdCertidaoNegativa(v.id);
            },
            shouldRender: (v) => !!v.pessoa,
          },
          {
            title: "Excluir",
            icon: () => <IoMdTrash size={22} />,
            onClick: (v: UnidadePaginateResponse) => {
              onDelete(v);
            },
          },
        ]}
        onRow={(record) => {
          return {
            onClick: () => {
              onClickRow(record);
            },
            style: {
              cursor: "pointer",
            },
          };
        }}
      />
      <ModalHistorico
        isOpenModal={!!idUnidadeHistorico}
        onClose={() => setIdUnidadeHistorico(undefined)}
        id={idUnidadeHistorico}
      />
      <ModalExportCertidaoNegativaDebitos
        onClose={() => setIdCertidaoNegativa(undefined)}
        visible={!!idCertidaoNegativa}
        defaultUnidadeId={idCertidaoNegativa}
      />
    </>
  );
}

export default UnidadesTable;
